var React = require('react');

function Web (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 18C14.4182 18 18 14.4182 18 10C18 5.58182 14.4182 2 10 2M10 18C5.58182 18 2 14.4182 2 10C2 5.58182 5.58182 2 10 2M10 18C12.1818 18 12.9091 14.3636 12.9091 10C12.9091 5.63636 12.1818 2 10 2M10 18C7.81818 18 7.09091 14.3636 7.09091 10C7.09091 5.63636 7.81818 2 10 2M2.72727 12.9091H17.2727M2.72727 7.09091H17.2727","stroke":"#36373A","strokeWidth":"1.25"}));
}

Web.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Web;

Web.default = Web;
